import FindAsset from './findAsset/PluginSetup.js';
export default {
  install: molten => {
    FindAsset.install(molten);
  }
};